import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { AnalyticResultItemEnum } from 'src/utils/enum';
import { ALL_MY_SURVEYS } from './constants';
import {
  AllListMySurveySuccess,
  AllListMySurveyError,
  AllListMySurveyDataActionTypes,
  IAllMySurveyState,
} from './types';

const initialState: IAllMySurveyState = {
  status: idle,
  data: [],
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: AllListMySurveyDataActionTypes,
  ): IAllMySurveyState => {
    switch (action.type) {
      case ALL_MY_SURVEYS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_MY_SURVEYS + SUCCESS: {
        draft.status = fulfilled;
        const data = (action as AllListMySurveySuccess).payload.items;
        draft.data = data.map((survey) => ({
          id: survey.id,
          name: survey.name,
          type: survey.type,
          item: {
            number: survey.items[0][AnalyticResultItemEnum.NUMBER]?.value,
            points: survey.items[0][AnalyticResultItemEnum.POINTS]?.value,
            passingScore:
              survey.items[0][AnalyticResultItemEnum.POINTS]?.passing_score,
            date: survey.items[0][AnalyticResultItemEnum.DATE]?.value,
            questions: survey.items[0].slice(3).map((answer) => ({
              points: answer?.points,
              is_required: answer?.is_required,
              rating: answer?.rating,
              comment: answer?.comment,
              title: answer?.title,
              type: answer?.type,
              question: answer?.title,
              answer: answer?.values, // ответы пользователя
              answers: answer?.answers, // варианты ответа, которые есть
            })), // первые три объекта массива - доп информация
          },
        }));
        break;
      }
      case ALL_MY_SURVEYS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllListMySurveyError).error;
        break;
      }
      case ALL_MY_SURVEYS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
